import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_CHATAPI_URL;

export async function getUserChatSubscription({ userId }) {
  const token = Cookies.get("authToken");
  
  if (!token) {
    console.warn("No auth token for getUserChatSubscription, returning defaults");
    return {
      chat_subscription_id: 1,
      daily_limit: 100
    };
  }
  
  try {
    // Use GET with auth header (matching apiHandlers.js)
    const { data } = await axios.get(
      `${BASE_URL}get-user-subscription?user_id=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    console.log("Chat subscription data:", data);
    return data;
  } catch (e) {
    if (e.response?.status === 404) {
      return {
        chat_subscription_id: 1,
        daily_limit: 100
      };
    }
    if (e.response?.status === 405) {
      // If GET is not allowed, try POST as fallback
      console.log("GET not allowed, trying POST for subscription");
      try {
        const { data } = await axios.post(
          `${BASE_URL}get-user-subscription?user_id=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        return data;
      } catch (postError) {
        console.error("Both GET and POST failed for subscription:", postError);
        return {
          chat_subscription_id: 1,
          daily_limit: 100
        };
      }
    }
    throw e;
  }
}